import { useState } from 'react'

import { CopyIcon, TickIcon } from '@/icons'

import s from './CopyToClipboard.module.css'

type Props = {
  text: string
}

export const CopyToClipboard = ({ text }: Props) => {
  const [isCopied, setIsCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(`https://g.to/${text}`)
      setIsCopied(true)
      setTimeout(() => setIsCopied(false), 1000)
    } catch {}
  }

  return (
    <span
      className={`${s.copy} ${isCopied ? s.highlighted : ''}`}
      onClick={handleCopy}
      title="Copy link"
      role="button"
    >
      {isCopied ? TickIcon : CopyIcon}
    </span>
  )
}
